"use client";
import { jsx, Fragment } from "react/jsx-runtime";
import { isBD } from "../../../../utils/businessType.lib.js";
import { useCriteo } from "../../../../utils/criteo/CriteoProvider.js";
import React, { useMemo } from "react";
import "../../../Chrome/BrowseContext/ContextProvider.js";
import { useBrowseContext } from "../../../Chrome/BrowseContext/hook.js";
import { ObservableProductTileUI } from "../ProductTileCarousel/ObservableProductTileUI.js";
import { useProductData } from "../ProductTileCarousel/utils.js";
import { ProductTileSkeleton } from "../../../Product/ProductTile/ProductTileUI/view.skeleton.js";
import { useCriteoAnalytics } from "./utils.js";
const COMPONENT_NAME = "CriteoProductTile";
function CriteoProductTile(props) {
  var _a, _b;
  const {
    itemNumber,
    placement,
    products,
    configData,
    sx,
    locale,
    variant,
    isHorizontal,
    inventoryAware,
    showActionButton,
    showReviews,
    showCompareProduct,
    isSponsored,
    WrapperComponent = React.Fragment,
    sponsoredDisplayVariant,
    product_tile_data_source
  } = props;
  const { bdWHNumber } = useCriteo();
  const { bdWarehouseNumber, wcMember, warehouse, bdDeliveryLocation } = useBrowseContext();
  const bdWarehouseNumberToUse = !bdWHNumber && isBD() ? bdWarehouseNumber == null ? void 0 : bdWarehouseNumber.value : bdWHNumber;
  const warehouseToUse = inventoryAware ? warehouse : void 0;
  const cookieContext = useMemo(() => {
    return {
      bdDeliveryLocation,
      wcMember,
      warehouse: warehouseToUse
    };
  }, [bdDeliveryLocation, wcMember, warehouseToUse]);
  const {
    isLoadingPopulatedProductData,
    populatedProductData,
    populatedProductDataError
  } = useProductData({
    inventoryAware,
    itemNumbers: itemNumber,
    locale,
    productTileConfigData: configData,
    bdWHNumber: bdWarehouseNumberToUse,
    product_tile_data_source,
    cookieContext
  });
  const analytics = useCriteoAnalytics({ placement, products });
  if (isLoadingPopulatedProductData) {
    return /* @__PURE__ */ jsx(WrapperComponent, { children: /* @__PURE__ */ jsx(ProductTileSkeleton, {}) });
  }
  const productApiResponse = (_a = populatedProductData == null ? void 0 : populatedProductData.productApiResponses) == null ? void 0 : _a[0];
  const lwData = (_b = populatedProductData == null ? void 0 : populatedProductData.lwResponses) == null ? void 0 : _b[0];
  if (populatedProductDataError || !(productApiResponse || lwData)) {
    return /* @__PURE__ */ jsx(Fragment, {});
  }
  return /* @__PURE__ */ jsx(WrapperComponent, { children: /* @__PURE__ */ jsx(
    ObservableProductTileUI,
    {
      containerSx: {
        padding: 0,
        paddingBottom: 0
      },
      analytics,
      configData,
      inventoryAware,
      isHorizontal,
      isSponsored,
      itemNumber,
      locale,
      productApiResponse,
      lwData,
      productTileSx: sx,
      showActionButton,
      showCompareProduct,
      showReviews,
      variant,
      isV1ProductTile: true,
      sponsoredDisplayVariant,
      isCriteo: true
    }
  ) });
}
CriteoProductTile.displayName = COMPONENT_NAME;
export {
  CriteoProductTile
};
